import React from 'react';

import { AutocompleteProps, Autocomplete as MUIAutocomplete } from '@mui/material';

import TextField from '../TextField';

const Autocomplete = (props:
Omit<AutocompleteProps<any, boolean, boolean, boolean, React.ElementType>, 'renderInput'>) =>
  (
    <MUIAutocomplete
      {...props}
      renderInput={(params) => (
        <TextField
          inputProps={{ ...params.inputProps }}
          autoFocus
          ref={params.InputProps.ref}
        />
      )}
    />
  );

export default Autocomplete;
